import logoLink from '../resources/emex.svg';

export const cssVariables = {};

export const logo = logoLink;
